export default __webpack_public_path__ + "static/media/nesto-online-deals.77ab1571.svg";